<template>
  <div class="container">
    <a
      href="/collections"
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      style="margin-top: 25px"
    >
      <div class="img-block">
        <img src="../img/zaplanirovat.svg" alt="" />
      </div>
      <span>Запланировать презентацию</span>
    </a>

    <a
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      href="/presentationList"
    >
      <div class="img-block">
        <img src="../img/calendar.svg" alt="" />
      </div>
      <span>Запланированные презентации</span>
    </a>
    <a class="main-item" href="#" @click.prevent="showCollection()">
      <div class="img-block">
        <img src="../img/collections.svg" alt="" />
      </div>
      <span>Коллекции</span>
    </a>
    <a
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      href="/control-registration"
    >
      <div class="img-block">
        <img src="../img/control.svg" alt="" />
      </div>
      <span>Контроль отстройки</span>
    </a>
    <a
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      href="/replacement-registration"
    >
      <div class="img-block">
        <img src="../img/replacement.svg" alt="" />
      </div>
      <span>Работа по замене</span>
    </a>
    <a
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      href="/shop-registration"
    >
      <div class="img-block">
        <img src="../img/shop.svg" alt="" />
      </div>
      <span>Заказать товар</span>
    </a>



    <a
      href="/clients"
      :class="{ disabled: presentationIsStarted }"
      class="main-item"
    >
      <div class="img-block">
        <img src="../img/identification.svg" alt="" />
      </div>
      <span>Клиенты</span>
    </a>
    
    
    
    
    <a
      class="main-item"
      :class="{ disabled: presentationIsStarted }"
      href="/history"
    >
      <div class="img-block">
        <img src="../img/history.svg" alt="" />
      </div>
      <span>История</span>
    </a>
    
    <a class="main-item" v-if="presentationIsStarted" :href="collectionUrl">
      <div class="img-block">
        <img src="../img/zaplanirovat.svg" alt="" />
      </div>
      <span>Вернуться к презентации</span>
    </a>
    <a v-if="!cartIsEmpty" class="main-item" href="/order">
      <div class="img-block">
        <img src="../img/shop.svg" alt="" />
      </div>
      <span>Перейти в корзину</span>
    </a>
  </div>
</template>

<script>
export default {
  data: () => ({
    userName: "",
    userLastName: "",
    presentationIsStarted: false,
    collectionUrl: "",
    cartIsEmpty: true,
  }),
  methods: {
    showCollection() {
      this.$localStorageSet("viewCollection", true);
      this.$router.push("/collections");
    },
  },
  created() {
    if (JSON.parse(localStorage.getItem("viewCollection"))) {
      localStorage.removeItem("viewCollection"); //Удалить режим просмотра для коллекции
    }

    let miniCart = this.$localStorageGet("miniCart");
    if (this.$localStorageGet("presentationStart")) {
      this.presentationIsStarted = true;
      this.collectionUrl =
        "catalog/" + this.$localStorageGet("presentationStartedID"); //Url текущей коллекции
    } else {
      this.presentationIsStarted = false;
      this.$store.dispatch("CLEAR_LOCAL_STORAGE");
    }

    if (Object.keys(miniCart).length != 0) {
      this.cartIsEmpty = false;
    }

    // Запретить переход через кнопку "назд" в браузере на главной странице
    history.pushState(null, document.title, location.href);
    window.addEventListener("popstate", function (event) {
      history.pushState(null, document.title, location.href);
    });
  },
};
</script>
<style lang="scss" scoped>
.user-name {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  font-weight: 500;
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 20px;
}

a {
  width: 100%;
  display: flex;
  font-weight: 500;
  font-size: 14px;
  color: #000;
  text-transform: uppercase;
  height: 45px;
  align-items: center;
  justify-content: center;
  background: #c4c4c4;
  margin-bottom: 15px;
}
.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.dev {
  position: relative;
  &:after {
    content: "dev";
    position: absolute;
    right: 0;
    border: 22px solid red;
    border-left-color: #c4c4c4;
    border-top-color: #c4c4c4;
    height: 45px;
    width: 45px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 10px;
  }
}
.main-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
  padding-right: 20px;
  span {
    flex-grow: 2;
    text-align: center;
    // padding-left: 20px;
  }
  img {
    width: auto;
    height: 40px;
    max-width: 40px;
  }
  .img-block {
    width: 70px;
    display: flex;
    justify-content: center;
  }
}
</style>